import { usePreferences } from 'hooks/usePreferences';
import { formatPhoneForDisplay } from '../../../utils/phoneUtils';

/**
 * Custom phone number cell renderer that formats phone numbers according to business preferences
 * Uses context-based preferences for instant loading (no delay)
 */
const PhoneNumberCell = ({ value }) => {
    const { preferences } = usePreferences();

    if (!value) return null;

    // Use the utility function to format the phone number
    // Preferences are immediately available via context, no loading delay
    const { displayText } = formatPhoneForDisplay(value, preferences);

    return displayText;
};

export const employeeColumns = [
    {
        Header: 'First Name',
        accessor: 'firstName',
        enableFilter: true,
    },
    {
        Header: 'Last Name',
        accessor: 'lastName',
        enableFilter: true
    },
    {
        Header: 'Phone',
        accessor: 'phone',
        disableSortBy: true,
        enableFilter: true,
        type: 'number',
        // Custom cell renderer for phone number formatting
        Cell: PhoneNumberCell
    },
    {
        Header: 'Email',
        accessor: 'email',
        enableFilter: true
    },
    {
        Header: 'Role',
        accessor: 'role',
        disableSortBy: true,
        enableFilter: true,
        type: 'enum',
        filterOptions: [
            {value: 'sales', label: 'Sales'},
            {value: 'manager', label: 'Manager'},
            {value: 'practitioner', label: 'Practitioner'},
            {value: 'accounting', label: 'Accounting'},
            {value: 'guest', label: 'Guest'},
            {value: 'admin', label: 'Admin'},
        ]
    },
];